"use strict";

var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["onSubmit", "id", "action", "children", "className"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formModule = _interopRequireDefault(require("./form.module.scss"));
//  Base form component
// ====================

const Form = _ref => {
  let {
      onSubmit,
      id,
      action,
      children,
      className
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const classNames = (0, _classnames.default)(_formModule.default.Form, className);
  return /*#__PURE__*/_react.default.createElement("form", (0, _extends2.default)({
    className: classNames,
    id: id,
    action: action,
    onSubmit: onSubmit
  }, restProps), children);
};
var _default = exports.default = Form;